import { useEffect } from "react";
import { load } from "@fingerprintjs/fingerprintjs";

const FingerprintProvider = ({ metaDispatch }) => {
  useEffect(() => {
    const fpPromise = load();
    fpPromise
      .then((fp) => fp.get())
      .then((result) => {
        const visitorId = result.visitorId;
        metaDispatch({
          type: "SET_FINGERPRINT",
          payload: visitorId,
        });
      });
  }, [metaDispatch]);

  return null;
};

export default FingerprintProvider;
